'use strict';

var chunkTI4S3S4J_js = require('./chunk-TI4S3S4J.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var d = require('react');
var f = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var d__default = /*#__PURE__*/_interopDefault(d);
var f__default = /*#__PURE__*/_interopDefault(f);

var m=f__default.default.h1`
  font-size: ${({$fontSize:o})=>o};
  font-weight: ${({$fontWeight:o})=>o};
  line-height: ${({$lineHeight:o})=>o};
  color: ${({$color:o})=>o};
  margin: 0;
  padding: 0;
`,$=({level:o,children:n,isBold:r=!1,color:s=""})=>{let t=chunkTI4S3S4J_js.a(),{tokens:a}=chunkHUKGHOBJ_js.b(),g=`h${o}`;return d__default.default.createElement(m,{as:g,$fontSize:t[o].fontSize,$lineHeight:t[o].lineHeight,$fontWeight:r?"var(--bold)":"var(--semibold)",$color:s||a.text_default_text_primary},n)};

exports.a = $;
